<mat-tab-group>
  <mat-tab label="Users">
    <!-- <bt-user-settings/> -->
</mat-tab>
<mat-tab label="Roles">
      <!-- <bt-roles-settings/> -->
  </mat-tab>
</mat-tab-group>